"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformGeometryBackendResponseError = exports.SdPlatformUnsupportedGrantTypeClientOAuthResponseError = exports.SdPlatformUnauthorizedClientOAuthResponseError = exports.SdPlatformInvalidGrantOAuthResponseError = exports.SdPlatformInvalidClientOAuthResponseError = exports.SdPlatformInvalidRequestOAuthResponseError = exports.SdPlatformOAuthResponseError = exports.SdPlatformValidationResponseError = exports.SdPlatformUnauthorizedResponseError = exports.SdPlatformForbiddenResponseError = exports.SdPlatformNotFoundResponseError = exports.SdPlatformResourceResponseError = exports.SdPlatformServerResponseError = exports.SdPlatformResponseError = exports.SdPlatformRequestError = exports.SdPlatformError = exports.ShapeDiverErrorType = void 0;
exports.ShapeDiverErrorType = {
    Generic: "sd_pb_sdk_generic",
    Request: "sd_pb_sdk_request",
    Response: "sd_pb_sdk_response",
    ServerResponse: "sd_pb_sdk_server_response",
    ResourceResponse: "sd_pb_sdk_resource_response",
    NotFoundResponse: "sd_pb_sdk_not_found_response",
    ForbiddenResponse: "sd_pb_sdk_forbidden_response",
    UnauthorizedResponse: "sd_pb_sdk_unauthorized_response",
    ValidationResponse: "sd_pb_sdk_validation_response",
    OAuthResponse: "sd_pb_sdk_oauth_response",
    InvalidRequestOAuthResponse: "sd_pb_sdk_invalid_request_oauth_response",
    InvalidClientOAuthResponse: "sd_pb_sdk_invalid_client_oauth_response",
    InvalidGrantOAuthResponse: "sd_pb_sdk_invalid_grant_oauth_response",
    UnauthorizedClientOAuthResponse: "sd_pb_sdk_unauthorized_client_oauth_response",
    UnsupportedGrantTypeClientOAuthResponse: "sd_pb_sdk_unsupported_grant_type_oauth_response",
    GeometryBackendResponse: "sd_pb_sdk_gb_response",
};
/**
 * Generic error
 */
class SdPlatformError extends Error {
    constructor(message) {
        super(message);
        this.errorType = exports.ShapeDiverErrorType.Generic;
    }
}
exports.SdPlatformError = SdPlatformError;
/**
 * Request error (request could not be sent etc)
 */
class SdPlatformRequestError extends SdPlatformError {
    constructor(message, desc) {
        super(message);
        this.desc = desc;
        this.errorType = exports.ShapeDiverErrorType.Request;
    }
}
exports.SdPlatformRequestError = SdPlatformRequestError;
/**
 * Generic response error
 */
class SdPlatformResponseError extends SdPlatformError {
    constructor(message, http_status_code) {
        super(message);
        this.http_status_code = http_status_code;
        this.errorType = exports.ShapeDiverErrorType.Response;
    }
}
exports.SdPlatformResponseError = SdPlatformResponseError;
/**
 * The server error which can just contain message and status code.
 */
class SdPlatformServerResponseError extends SdPlatformResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.ServerResponse;
    }
}
exports.SdPlatformServerResponseError = SdPlatformServerResponseError;
/**
 * Resource response error
 */
class SdPlatformResourceResponseError extends SdPlatformResponseError {
    constructor(message, http_status_code, error, error_description, error_uri, code) {
        super(message, http_status_code);
        this.error = error;
        this.error_description = error_description;
        this.error_uri = error_uri;
        this.code = code;
        this.errorType = exports.ShapeDiverErrorType.ResourceResponse;
    }
}
exports.SdPlatformResourceResponseError = SdPlatformResourceResponseError;
/**
 * Not found error, returned with 404 status.
 */
class SdPlatformNotFoundResponseError extends SdPlatformResourceResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.NotFoundResponse;
    }
}
exports.SdPlatformNotFoundResponseError = SdPlatformNotFoundResponseError;
/**
 * Forbidden error, returned with 403 status.
 */
class SdPlatformForbiddenResponseError extends SdPlatformResourceResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.ForbiddenResponse;
    }
}
exports.SdPlatformForbiddenResponseError = SdPlatformForbiddenResponseError;
/**
 * Unauthorized error, returned with 401 status.
 */
class SdPlatformUnauthorizedResponseError extends SdPlatformResourceResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.UnauthorizedResponse;
    }
}
exports.SdPlatformUnauthorizedResponseError = SdPlatformUnauthorizedResponseError;
class SdPlatformValidationResponseError extends SdPlatformResourceResponseError {
    constructor(message, http_status_code, error, error_description, error_uri, code, fields) {
        super(message, http_status_code, error, error_description, error_uri, code);
        this.fields = fields;
        this.errorType = exports.ShapeDiverErrorType.ValidationResponse;
    }
}
exports.SdPlatformValidationResponseError = SdPlatformValidationResponseError;
/**
 * Authentication response error.
 * Follows principles of OAuth 2.0
 * Please see https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.2.1
 */
class SdPlatformOAuthResponseError extends SdPlatformResponseError {
    constructor(message, http_status_code, 
    /**
     * required error code
     *
     *   * invalid_request
     *   * unauthorized_client
     *   * access_denied
     *   * unsupported_response_type
     *   * invalid_scope
     *   * server_error
     *   * temporarily_unavailable
     */
    error, 
    /** optional human-readable text providing additional information */
    error_description, 
    /** optional URI identifying a human-readable web page with
     information about the error */
    error_uri) {
        super(message, http_status_code);
        this.error = error;
        this.error_description = error_description;
        this.error_uri = error_uri;
        this.errorType = exports.ShapeDiverErrorType.OAuthResponse;
    }
}
exports.SdPlatformOAuthResponseError = SdPlatformOAuthResponseError;
/**
 * Authentication response error.
 * Follows principles of OAuth 2.0
 * Please see https://datatracker.ietf.org/doc/html/rfc6749#section-5.2
 */
class SdPlatformInvalidRequestOAuthResponseError extends SdPlatformOAuthResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.InvalidRequestOAuthResponse;
    }
}
exports.SdPlatformInvalidRequestOAuthResponseError = SdPlatformInvalidRequestOAuthResponseError;
/**
 * Authentication response error.
 * Follows principles of OAuth 2.0
 * Please see https://datatracker.ietf.org/doc/html/rfc6749#section-5.2
 */
class SdPlatformInvalidClientOAuthResponseError extends SdPlatformOAuthResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.InvalidClientOAuthResponse;
    }
}
exports.SdPlatformInvalidClientOAuthResponseError = SdPlatformInvalidClientOAuthResponseError;
/**
 * Authentication response error.
 * Follows principles of OAuth 2.0
 * Please see https://datatracker.ietf.org/doc/html/rfc6749#section-5.2
 */
class SdPlatformInvalidGrantOAuthResponseError extends SdPlatformOAuthResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.InvalidGrantOAuthResponse;
    }
}
exports.SdPlatformInvalidGrantOAuthResponseError = SdPlatformInvalidGrantOAuthResponseError;
/**
 * Authentication response error.
 * Follows principles of OAuth 2.0
 * Please see https://datatracker.ietf.org/doc/html/rfc6749#section-5.2
 */
class SdPlatformUnauthorizedClientOAuthResponseError extends SdPlatformOAuthResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.UnauthorizedClientOAuthResponse;
    }
}
exports.SdPlatformUnauthorizedClientOAuthResponseError = SdPlatformUnauthorizedClientOAuthResponseError;
/**
 * Authentication response error.
 * Follows principles of OAuth 2.0
 * Please see https://datatracker.ietf.org/doc/html/rfc6749#section-5.2
 */
class SdPlatformUnsupportedGrantTypeClientOAuthResponseError extends SdPlatformOAuthResponseError {
    constructor() {
        super(...arguments);
        this.errorType = exports.ShapeDiverErrorType.UnsupportedGrantTypeClientOAuthResponse;
    }
}
exports.SdPlatformUnsupportedGrantTypeClientOAuthResponseError = SdPlatformUnsupportedGrantTypeClientOAuthResponseError;
/**
 * Geometry backend response error forwarded by the platform backend
 */
class SdPlatformGeometryBackendResponseError extends SdPlatformError {
    constructor(message, error, desc) {
        super(message);
        this.error = error;
        this.desc = desc;
        this.errorType = exports.ShapeDiverErrorType.GeometryBackendResponse;
    }
}
exports.SdPlatformGeometryBackendResponseError = SdPlatformGeometryBackendResponseError;
//# sourceMappingURL=SdPlatformErrors.js.map